const isNotNullOrEmpty = (value: any) => {
    if (Array.isArray(value)) return value.length > 0;
    return value !== undefined && value !== null && value !== '';
}

export default isNotNullOrEmpty;